import {AxiosResponse} from 'axios';
import {
  ContractsModel,
  DeleteContractsResponse,
  PostContractsModel,
} from 'library/src/contracts/models/ContractsModel';
import api, {wagoNestApiUrl} from 'shared/services/ApiConfig';
import PixagriScopes from '../../../library/src/core/models/PixagriScopes';

export class PixagriContractApiService {
  CAMPAIGN_YEAR_QUERY = 'campaign_year';
  DELETE_ENPOINT = '/delete';

  contractBaseUrl() {
    return `${wagoNestApiUrl}/${PixagriScopes.CONTRACTS}`;
  }

  getContractsUrl(campaign_year?: number) {
    let baseUrl = this.contractBaseUrl();
    if (campaign_year) {
      baseUrl = baseUrl + `?${this.CAMPAIGN_YEAR_QUERY}=${campaign_year}`;
    }
    return baseUrl;
  }

  getDeleteContractUrl(contract: ContractsModel) {
    return `${this.contractBaseUrl()}/${contract.id}`;
  }

  async getContracts(campaign_year?: number): Promise<ContractsModel[]> {
    const url = this.getContractsUrl(campaign_year);
    const res: AxiosResponse<ContractsModel[]> = await api.get(url);
    return res.data;
  }

  async postContracts(contracts: PostContractsModel) {
    const url = this.contractBaseUrl();
    const res: AxiosResponse<ContractsModel[]> = await api.post(url, contracts);
    return res.data;
  }

  async deleteContracts(contract: ContractsModel) {
    const url = this.getDeleteContractUrl(contract);
    const response: AxiosResponse<DeleteContractsResponse> = await api.delete(
      url,
    );
    return response.data;
  }
}

const pixagriContractApiService = new PixagriContractApiService();
export default pixagriContractApiService;
